import { Subject } from 'rxjs';
const depositNotPaid = new Subject<string>();

export const warningService = {
  onWarning: (message: string) => depositNotPaid.next(message),
  warning$: depositNotPaid.asObservable()
};
